import React, { useState, Fragment } from "react";
import { useStyles } from "./styles";
import { aberturaTicketNovo, gestaoTicketNovo } from "./actions";
import HelpIcon from "@material-ui/icons/Help";
import {
  Typography,
  IconButton,
  Card,
  CardContent,
  Popover,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import ModalHubspot from "../../ModalHubspot";

export default function Atendimento() {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();
  const [visivel, setVisivel] = useState(false);


  function openLink(link, newTab) {
    const target = newTab ? "_blank" : "_self";
    window.open(link, target);
  }

  return (
    <Fragment>
      <IconButton
        aria-controls="atendimento"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <HelpIcon className={classes.atendimento} />
      </IconButton>
      <Popover
        id="usuario"
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Card>
          <CardContent>
            <div className={classes.tituloAtendimento}>
              <Typography className={classes.titloCard}>
                e-Atendimento
              </Typography>
            </div>

            <div className={classes.actions}>
              <List>
                <ListItem button onClick={aberturaTicketNovo}>
                  <ListItemText primary="Abertura de ticket (novo)" />
                </ListItem>
                <ListItem button onClick={gestaoTicketNovo}>
                  <ListItemText primary="Gestão de tickets (novo)" />
                </ListItem>
                <ListItem button>
                  <ListItemText
                    primary="Gestão de tickets (antigo)"
                    onClick={() =>
                      openLink("https://conta.e-auditoria.com.br/Tickets", true)
                    }
                  />
                </ListItem>
                 <ListItem button onClick={() => setVisivel(true)}>
                  <ListItemText primary="Solicitar Upgrade" />
                </ListItem>
                <ListItem button>
                  <ListItemText
                    primary="FAQ"
                    onClick={() =>
                      openLink("http://e-auditoria.com.br/faq/", true)
                    }
                  />
                </ListItem>
                <ListItem
                  button
                  onClick={() =>
                    openLink(
                      "https://conta.e-auditoria.com.br/Home/Manual",
                      true
                    )
                  }
                >
                  <ListItemText primary="Manual" />
                </ListItem>
                <ListItem
                  button
                  onClick={() =>
                    openLink(
                      "http://www.e-auditoria.com.br/materiais-educacionais/",
                      true
                    )
                  }
                >
                  <ListItemText primary="Materiais Educacionais" />
                </ListItem>
              </List>
            </div>
          </CardContent>
        </Card>
      </Popover>
      <ModalHubspot titulo="Descubra como a nova e-Auditoria pode transformar seu escritório" visivel={visivel} setVisivel={setVisivel} />
    </Fragment>
  );
}
